import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiKeysService from "../../api/api_keys";


export const getApiKeys = createAsyncThunk(
  "api_keys/get",
  async (args, thunkAPI) => {
    try {
      const response = await ApiKeysService.getApiKeys(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getApiKeyDetail = createAsyncThunk(
  "apiKeyDetail/get",
  async (args, thunkAPI) => {
    try {
      const response = await ApiKeysService.getApiKeyDetail(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createApiKey = createAsyncThunk(
  "apiKeyDetail/post",
  async (args, thunkAPI) => {
    try {
      const response = await ApiKeysService.createApiKey(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteApiKey = createAsyncThunk(
  "apiKey/delete",
  async (args, thunkAPI) => {
    try {
      const response = await ApiKeysService.deleteApiKey(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  results: [],
  count: 0,
  next: null,
  previous: null,
  apiKeyData: null,
  error: null,
  loadingUpdate: false,
};

const apiKeysSlice = createSlice({
  name: "api_keys",
  initialState,
  reducers: {
    clearApiKeyData(state) {
      state.apiKeyData = null;
    }
  },
  extraReducers: {
    [getApiKeys.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
    },
    [getApiKeys.rejected]: (state, action) => {
      state.error = gettext("Could not fetch API keys");
    },
    [getApiKeyDetail.fulfilled]: (state, action) => {
      state.selectedApiKey = action.payload;
    },
    [getApiKeyDetail.rejected]: (state, action) => {
      state.error = gettext("Could not fetch API key");
    },
    [createApiKey.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [createApiKey.fulfilled]: (state, action) => {
      state.apiKeyData = action.payload
      state.loadingUpdate = false;
    },
    [createApiKey.rejected]: (state, action) => {
      state.error = "Ekki tókst að búa til API lykil";
      state.loadingUpdate = false;
    },
  },
});

export const { clearApiKeyData } = apiKeysSlice.actions;
const { reducer } = apiKeysSlice;
export default reducer;